// Zentrale Übersetzungen für Deutsch / Englisch (i18n)
export const translations = {
  de: {
    appName: "VK ToDo",
    appTagline: "Tagesaufgaben",
    // Dashboard
    dashboard: "Übersicht",
    total: "Aufgaben gesamt",
    open: "Offen",
    completed: "Erledigt",
    progress: "Fortschritt",
    // Add task
    addPlaceholder: "Neue Aufgabe hinzufügen …",
    addButton: "Aufgabe hinzufügen",
    category: "Kategorie",
    dueDate: "Fällig am",
    noCategory: "Keine Kategorie",
    emptyError: "Bitte gib zuerst eine Aufgabe ein.",
    added: "Aufgabe hinzugefügt",
    // Filters
    filterAll: "Alle",
    filterActive: "Aktiv",
    filterDone: "Erledigt",
    search: "Aufgaben durchsuchen …",
    // Sort
    sortLabel: "Sortieren",
    sortNewest: "Neueste zuerst",
    sortOldest: "Älteste zuerst",
    sortAlpha: "Alphabetisch",
    sortDoneLast: "Erledigte zuletzt",
    // Task item
    createdOn: "Erstellt",
    edit: "Bearbeiten",
    delete: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    // Bulk
    deleteDone: "Erledigte löschen",
    deleteAll: "Alle löschen",
    // Dialogs
    confirmDeleteTitle: "Aufgabe löschen?",
    confirmDeleteDesc: "Diese Aktion kann nicht rückgängig gemacht werden.",
    confirmDoneTitle: "Alle erledigten Aufgaben löschen?",
    confirmDoneDesc: "Alle abgeschlossenen Aufgaben werden dauerhaft entfernt.",
    confirmAllTitle: "Wirklich alle Aufgaben löschen?",
    confirmAllDesc: "Deine gesamte Aufgabenliste wird dauerhaft gelöscht.",
    deleted: "Aufgabe gelöscht",
    updated: "Aufgabe aktualisiert",
    // Empty states
    emptyTitle: "Alles erledigt!",
    emptyDesc: "Du hast aktuell keine offenen Aufgaben. Zeit für eine Pause.",
    noResults: "Keine passenden Aufgaben gefunden.",
    editTitle: "Aufgabe bearbeiten",
    // Voice / Reminder / Timer / Alarm
    voiceHint: "Aufgabe sprechen",
    listening: "Ich höre zu …",
    transcribing: "Wird umgewandelt …",
    voiceError: "Spracherkennung fehlgeschlagen.",
    reminder: "Erinnerung / Wecker",
    noReminder: "Keine Erinnerung",
    timer: "Timer",
    minutes: "Minuten",
    start: "Starten",
    forTask: "Für Aufgabe (optional)",
    focusLabel: "Fokus-Sitzung",
    alarmTitle: "Wecker",
    time: "Uhrzeit",
    alarmLabelPlaceholder: "Beschriftung (optional)",
    noAlarms: "Noch keine Wecker gestellt.",
    dismiss: "Stoppen",
    ringReminder: "Erinnerung",
    ringAlarm: "Wecker",
    timerFinished: "Timer abgelaufen",
    startTimerForTask: "Timer starten",
    // Categories
    catWork: "Arbeit",
    catPersonal: "Privat",
    catSchool: "Schule",
    catShopping: "Einkauf",
    catUrgent: "Dringend",
    catOther: "Sonstiges",
    // Priority
    priority: "Priorität",
    prioLow: "Niedrig",
    prioMedium: "Mittel",
    prioHigh: "Hoch",
    // Repeat
    repeat: "Wiederholen",
    repeatNone: "Keine Wiederholung",
    repeatDaily: "Täglich",
    repeatWeekdays: "Werktags (Mo–Fr)",
    repeatWeekly: "Wöchentlich",
    repeatMonthly: "Monatlich",
    sortPriority: "Nach Priorität",
    overdue: "Überfällig",
    // Push
    enablePush: "Push aktivieren",
    pushEnabled: "Push aktiv",
    pushDenied: "Benachrichtigungen wurden blockiert.",
    pushUnsupported: "Push wird nicht unterstützt.",
    pushSuccess: "Push-Benachrichtigungen aktiviert!",
    dueTime: "Fällig (Datum & Uhrzeit)",
    notes: "Notizen",
    notesPlaceholder: "Notizen hinzufügen …",
    checklist: "Checkliste / Einkaufsliste",
    addItem: "Punkt hinzufügen …",
    viewList: "Liste",
    viewCalendar: "Kalender",
    noTasksThisDay: "Keine Aufgaben an diesem Tag.",
    today: "Heute",
    ad: "Anzeige",
    visitWebsite: "Website besuchen",
    createdBy: "Erstellt von",
    octopusTitle: "100 € geschenkt beim Wechsel zu Octopus Energy",
    octopusSub: "Einfach & Fair · Ausgezeichneter Kundenservice · Energie mit Zukunft",
    octopusCta: "Jetzt wechseln",
    tarifcheckText: "Versicherungen & Tarife kostenlos vergleichen – auf Tarifcheck.de",
    installTitle: "App installieren",
    installDesc: "Füge VK ToDo zu deinem Startbildschirm hinzu.",
    install: "Installieren",
    later: "Später",
    // Auth
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    name: "Name",
    email: "E-Mail",
    password: "Passwort",
    authLoginTitle: "Willkommen zurück",
    authLoginSub: "Melde dich an, um deine Aufgaben zu sehen.",
    authRegisterTitle: "Konto erstellen",
    authRegisterSub: "Registriere dich und starte mit deinen Aufgaben.",
    noAccount: "Noch kein Konto?",
    haveAccount: "Bereits registriert?",
    namePlaceholder: "Dein Name",
    emailPlaceholder: "name@beispiel.de",
    passwordPlaceholder: "Mindestens 6 Zeichen",
    profile: "Profil",
    profileTitle: "Profil bearbeiten",
    newPassword: "Neues Passwort (optional)",
    newPasswordPlaceholder: "Leer lassen zum Beibehalten",
    profileUpdated: "Profil aktualisiert",
    loginSuccess: "Erfolgreich angemeldet",
    registerSuccess: "Konto erstellt",
    loggedOut: "Abgemeldet",
    authError: "Anmeldung fehlgeschlagen",
  },
  en: {
    appName: "VK ToDo",
    appTagline: "Daily Tasks",
    dashboard: "Overview",
    total: "Total tasks",
    open: "Open",
    completed: "Completed",
    progress: "Progress",
    addPlaceholder: "Add a new task …",
    addButton: "Add task",
    category: "Category",
    dueDate: "Due date",
    noCategory: "No category",
    emptyError: "Please enter a task first.",
    added: "Task added",
    filterAll: "All",
    filterActive: "Active",
    filterDone: "Completed",
    search: "Search tasks …",
    sortLabel: "Sort",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortAlpha: "Alphabetical",
    sortDoneLast: "Completed last",
    createdOn: "Created",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    deleteDone: "Delete completed",
    deleteAll: "Delete all",
    confirmDeleteTitle: "Delete task?",
    confirmDeleteDesc: "This action cannot be undone.",
    confirmDoneTitle: "Delete all completed tasks?",
    confirmDoneDesc: "All completed tasks will be permanently removed.",
    confirmAllTitle: "Delete all tasks?",
    confirmAllDesc: "Your entire task list will be permanently deleted.",
    deleted: "Task deleted",
    updated: "Task updated",
    emptyTitle: "All done!",
    emptyDesc: "You have no open tasks right now. Time for a break.",
    noResults: "No matching tasks found.",
    editTitle: "Edit task",
    voiceHint: "Speak task",
    listening: "Listening …",
    transcribing: "Transcribing …",
    voiceError: "Speech recognition failed.",
    reminder: "Reminder / Alarm",
    noReminder: "No reminder",
    timer: "Timer",
    minutes: "Minutes",
    start: "Start",
    forTask: "For task (optional)",
    focusLabel: "Focus session",
    alarmTitle: "Alarm clock",
    time: "Time",
    alarmLabelPlaceholder: "Label (optional)",
    noAlarms: "No alarms set yet.",
    dismiss: "Stop",
    ringReminder: "Reminder",
    ringAlarm: "Alarm",
    timerFinished: "Timer finished",
    startTimerForTask: "Start timer",
    catWork: "Work",
    catPersonal: "Personal",
    catSchool: "School",
    catShopping: "Shopping",
    catUrgent: "Urgent",
    catOther: "Other",
    priority: "Priority",
    prioLow: "Low",
    prioMedium: "Medium",
    prioHigh: "High",
    repeat: "Repeat",
    repeatNone: "No repeat",
    repeatDaily: "Daily",
    repeatWeekdays: "Weekdays (Mon–Fri)",
    repeatWeekly: "Weekly",
    repeatMonthly: "Monthly",
    sortPriority: "By priority",
    overdue: "Overdue",
    enablePush: "Enable push",
    pushEnabled: "Push on",
    pushDenied: "Notifications were blocked.",
    pushUnsupported: "Push is not supported.",
    pushSuccess: "Push notifications enabled!",
    dueTime: "Due (date & time)",
    notes: "Notes",
    notesPlaceholder: "Add notes …",
    checklist: "Checklist / Shopping list",
    addItem: "Add item …",
    viewList: "List",
    viewCalendar: "Calendar",
    noTasksThisDay: "No tasks on this day.",
    today: "Today",
    ad: "Ad",
    visitWebsite: "Visit website",
    createdBy: "Created by",
    octopusTitle: "€100 free when you switch to Octopus Energy",
    octopusSub: "Simple & Fair · Excellent customer service · Energy with a future",
    octopusCta: "Switch now",
    tarifcheckText: "Compare insurances & tariffs for free – on Tarifcheck.de",
    installTitle: "Install app",
    installDesc: "Add VK ToDo to your home screen.",
    install: "Install",
    later: "Later",
    // Auth
    login: "Sign in",
    register: "Sign up",
    logout: "Sign out",
    name: "Name",
    email: "Email",
    password: "Password",
    authLoginTitle: "Welcome back",
    authLoginSub: "Sign in to see your tasks.",
    authRegisterTitle: "Create account",
    authRegisterSub: "Sign up and start managing your tasks.",
    noAccount: "No account yet?",
    haveAccount: "Already registered?",
    namePlaceholder: "Your name",
    emailPlaceholder: "name@example.com",
    passwordPlaceholder: "At least 6 characters",
    profile: "Profile",
    profileTitle: "Edit profile",
    newPassword: "New password (optional)",
    newPasswordPlaceholder: "Leave empty to keep current",
    profileUpdated: "Profile updated",
    loginSuccess: "Signed in successfully",
    registerSuccess: "Account created",
    loggedOut: "Signed out",
    authError: "Authentication failed",
  },
};

// Kategorien mit Farben (Schlüssel bleibt sprachunabhängig)
export const CATEGORIES = [
  { key: "work", labelKey: "catWork", color: "#2563EB" },
  { key: "personal", labelKey: "catPersonal", color: "#8B5CF6" },
  { key: "school", labelKey: "catSchool", color: "#0EA5E9" },
  { key: "shopping", labelKey: "catShopping", color: "#10B981" },
  { key: "urgent", labelKey: "catUrgent", color: "#EF4444" },
  { key: "other", labelKey: "catOther", color: "#64748B" },
];

export const getCategory = (key) => CATEGORIES.find((c) => c.key === key);

// Prioritäten
export const PRIORITIES = [
  { key: "low", labelKey: "prioLow", color: "#10B981", rank: 1 },
  { key: "medium", labelKey: "prioMedium", color: "#F59E0B", rank: 2 },
  { key: "high", labelKey: "prioHigh", color: "#EF4444", rank: 3 },
];

export const getPriority = (key) => PRIORITIES.find((p) => p.key === key) || PRIORITIES[1];

// Wiederholungen
export const REPEATS = [
  { key: "none", labelKey: "repeatNone" },
  { key: "daily", labelKey: "repeatDaily" },
  { key: "weekdays", labelKey: "repeatWeekdays" },
  { key: "weekly", labelKey: "repeatWeekly" },
  { key: "monthly", labelKey: "repeatMonthly" },
];
